import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import "../utils/style.css";
import orangeAccount from "../../../assets/images/orangeAccount.svg";
import redAccount from "../../../assets/images/redAccount.svg";
import purpleAccount from "../../../assets/images/purpleAccount.svg";
import { getMetricsByBusIdPerOperator } from "../../developer/services/developerApi";
import { useQuery } from "react-query";

const TransfertOperator = () => {

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const merchandId = currentUser?.user?.id;
  const { data: transOperator, isLoading: isLoadingMetric, isError: isErrorMetric, error: errorMetric } = useQuery(
    ["transOperator", merchandId],
    () => getMetricsByBusIdPerOperator(merchandId),
    { enabled: !!merchandId }
  );
  
  return (
    <Card className="transfert-operator-card">
      <div className="transfert-operator-header">Transferts par opérateurs</div>
      <CardBody>
        <Row>
          <Col lg={12}>
            <div className="transfert-operator-item">
              <div className="transfert-operator-text">
                <p className="transfert-operator-name">Mobile Money</p>
                <p className="transfert-operator-value">{ transOperator?.mobile_money}</p>
              </div>
              <img src={redAccount} className="transfert-operator-img" alt="Mobile Money" />
            </div>
          </Col>
          <Col lg={12}>
            <div className="transfert-operator-item">
              <div className="transfert-operator-text">
                <p className="transfert-operator-name">Carte Virtuelle</p>
                <p className="transfert-operator-value">{ transOperator?.virtual_card}</p>
              </div>
              <img src={purpleAccount} className="transfert-operator-img" alt="Carte Virtuelle" />
            </div>
          </Col>
          <Col lg={12}>
            <div className="transfert-operator-item">
              <div className="transfert-operator-text">
                <p className="transfert-operator-name">Carte Physique</p>
                <p className="transfert-operator-value">{ transOperator?.bank_card}</p>
              </div>
              <img src={orangeAccount} className="transfert-operator-img" alt="Carte Physique" />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default TransfertOperator;
